
<div class="col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2" *ngIf="!dataLoaded && !flyBack && !upsellbookingStatus.showUpsellScreen">
  <div class="loader-container">
    <!-- <div class="loader">
      <svg class="circular" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" />
      </svg>
    </div> -->
    <div class="flightDateSelection"></div>
    <div class="subtitle"></div>
    <div class="timeslotTabs"></div>
    <div class="singleSlotLoadWraper">
      <div class="singleSlotLoad"></div>
      <div class="singleSlotLoad"></div>
      <div class="singleSlotLoad"></div>
      <div class="singleSlotLoad"></div>
      <div class="singleSlotLoad"></div>
      <div class="laterButton"></div>
    </div>
    <div class="checkBoxText"></div>
    <div class="buttonContinueload"></div>


  </div>
</div>

  <app-upsell-booking *ngIf="upsellbookingStatus.showUpsellScreen" [styledClass]="'col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 fadeInUp'"
    [appCopy]='appCopy' [selectedLanguage]="selectedLanguage">
  </app-upsell-booking>


<section class="col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 fadeInUp" *ngIf="!upsellbookingStatus.showUpsellScreen && dataLoaded && (!(flyBack && !this.flyBackRedirect) || (flyBack && flyBackRedirect))">
  <div>
    <app-language-selector></app-language-selector>
    <button id="collection-back" type="button" class="btn btn-link hidden-sm hidden-xs back-btn"
      *ngIf="bookingType !== 'amend'" (click)="goBack()">
      <i class="icon">chevron_left</i>{{ appCopy.panelHeader['backLink'+selectedLanguage] }}
    </button>
  </div>

  <button type="button" class="btn btn-link back-btn" *ngIf="bookingType === 'amend'" (click)="cancelAmend()">
    <i class="icon">chevron_left</i>{{ appCopy.panelHeader['cancel'+selectedLanguage] }}
  </button>

  <h1 class="margin-bottom-16 text-dark-blue h1">{{ appCopy.panelHeader['title'+selectedLanguage] }}</h1>



  <p class="visible-xs mobile-uppercase-header">{{ flightDirection === 1 ?
    appCopy.panelHeader['dateOfPickup'+selectedLanguage] : appCopy.panelHeader['dateOfDelivery'+selectedLanguage] }}</p>



  <form #formBagPickupTimeDate="ngForm" id="pickUpTime" name="formBagPickupTimeDate" *ngIf="dataLoaded" novalidate>

    <!-- SBB Confirmation Success-->
    <div class="alert alert-success flex-always" *ngIf="isSbbSubsidyApplied">
      <i class="icon">tick</i>
      <div>
        <h4>{{ appCopy.panelHeader['discountAddedTitle'+selectedLanguage] }}</h4>
        <div>{{ appCopy.panelHeader['sbbDiscountConfirmation'+selectedLanguage] }}</div>
      </div>
    </div>

    <!-- Cat Discount Confirmation Success-->
    <div class="alert alert-success flex-always" *ngIf="isCatDiscountApplied">
      <i class="icon">tick</i>
      <div>
        <h4>{{ appCopy.panelHeader['discountAddedTitle'+selectedLanguage] }}</h4>
        <div>{{ appCopy.panelHeader['catDiscountConfirmation'+selectedLanguage] }}</div>
      </div>
    </div>

    <!-- LX half promotion-->
    <div class="alert alert-success flex-always" *ngIf="this.noOfFreeBags > 0">
      <i class="icon">tick</i>
      <div>
        <h4>{{ appCopy.panelHeader['discountAddedTitle'+selectedLanguage] }}</h4>
        <div>{{ appCopy.panelHeader['lxHalfPromotion'+selectedLanguage] }}</div>
      </div>
    </div>

    <!-- promo - valid -->
    <div *ngIf="timeslotMessageDetails.showMessage && timeslotMessageDetails.isValid && timeslotMessageDetails?.translationMessage.length > 0"
      class="alert alert-success flex-always">
      <i class="icon">tick</i>
      <div>
        <h4>{{appCopy.panelHeader[timeslotMessageDetails.title+selectedLanguage]
          ? appCopy.panelHeader[timeslotMessageDetails.title+selectedLanguage]
          : timeslotMessageDetails.title}}</h4>
        <!-- <div [innerHtml]="timeslotMessageDetails.message"></div> -->
        <div>
          <p *ngFor="let item of  timeslotMessageDetails.translationMessage">{{
            appCopy.panelHeader[item+selectedLanguage]
            ? appCopy.panelHeader[item+selectedLanguage]
            .replace('{rewardAmount}',
            timeslots.timeSlotPromotion.translationValidationErrors.parameters['rewardAmount'])
            .replace('{rewardTypeDesignator}',
            timeslots.timeSlotPromotion.translationValidationErrors.parameters['rewardTypeDesignator'])
            : appCopy.panelHeader[item+selectedLanguage]
            }}</p>
        </div>
      </div>
    </div>
    <!-- promo - invalid -->
    <div *ngIf="timeslotMessageDetails.showMessage && !timeslotMessageDetails.isValid && timeslotMessageDetails?.translationMessage.length > 0"
      class="alert alert-danger flex-always">
      <i class="icon">alert</i>
      <div>
        <h4>{{appCopy.panelHeader[timeslotMessageDetails.title+selectedLanguage] ?
          appCopy.panelHeader[timeslotMessageDetails.title+selectedLanguage] : timeslotMessageDetails.title}}</h4>
        <!-- <div [innerHtml]="timeslotMessageDetails.message"></div> -->
        <div>
          <p *ngFor="let item of  timeslotMessageDetails.translationMessage">
            {{appCopy.panelHeader[item+selectedLanguage]
            ? appCopy.panelHeader[item+selectedLanguage]
            : item }}</p>
        </div>
      </div>
    </div>

    <!-- product tier - valid -->
    <div *ngIf="timeslotMessageProductTierDetails.showMessage && timeslotMessageProductTierDetails.isValid"
      class="alert alert-success flex-always">
      <i class="icon">tick</i>
      <div>
        <h4>{{timeslotMessageProductTierDetails.title}}</h4>
        <div [innerHtml]="timeslotMessageProductTierDetails.message"></div>
      </div>
    </div>
    <!-- product tier - invalid -->
    <div *ngIf="timeslotMessageProductTierDetails.showMessage && !timeslotMessageProductTierDetails.isValid"
      class="alert alert-danger flex-always">
      <i class="icon">alert</i>
      <div>
        <h4 class="hidden-sm hiddne-xs">{{timeslotMessageProductTierDetails.title}}</h4>
        <h5 class="hidden-lg hidden-md">{{timeslotMessageProductTierDetails.title}}</h5>
        <div [innerHtml]="timeslotMessageProductTierDetails.message"></div>
      </div>
    </div>

    <!-- show warning if amend that price may have increased -->
    <div *ngIf="bookingType === 'amend'" class="alert alert-danger">
      <p>{{ appCopy.panelHeader['amendWarning'+selectedLanguage] }}</p>
    </div>

    <!-- <ng-container *ngIf="flightDirection === 2">
      <div class="alert"
        [ngClass]="airportTimeslotsWarning || bookingJourneyTimeAmended ? 'alert-danger' : 'alert-success'">

        <p *ngIf="airportTimeslotsWarning">
          Your flight lands out of our operational hours. Please check you're happy with the timeslot we've allocated
          for drop off.
        </p>
        <p>
          <span *ngIf="newTimeslotSelected && bookingJourneyTimeAmended && bookingType === 'amend'">
            Warning: your airport timeslot has been reset<br>
          </span>
          Drop off your bags in {{ flightStatusDetails[flightStatusDetails.length - 1].arrivalAirport.airportName }}
          Terminal {{ flightStatusDetails[flightStatusDetails.length - 1].arrivalAirport.airportTerminal }} on<br>
          <strong>{{ timeslots.sdsInboundCollectionTimeSlot.date | amParse: 'DD/MM/YYYY'
            | amDateFormat: 'ddd, D MMM YYYY' }} between {{ timeslots.sdsInboundCollectionTimeSlot.startTime }} and {{
            timeslots.sdsInboundCollectionTimeSlot.endTime }}</strong>
        </p>
      </div>
      <p class="text-muted">
        <em class="help-block larger">
          Want a different time? Finish your booking and give our team a call.
        </em>
      </p>
    </ng-container> -->

    <div class="radio-pills margin-bottom-16">
      <div *ngIf="showCalendar" class="radio radio--pill radio--calendar"
        [class.flex__item--order-last]="flightDirection === 2">
        <app-datepicker [selectedDate]="!isRadioDate && currentDate" [minDate]="calendarMinDate"
          [maxDate]="calendarMaxDate" [disableDates]="disableDates" [forTimeslot]="true" [labelText]="appCopy.panelHeader[calendarLabelText+selectedLanguage]"
          (dateChange)="setSelectedDate($event)">
        </app-datepicker>
      </div>

      <div *ngFor="let date of radioDates; let i = index" class="radio radio--pill">
        <input type="radio" name="date" [id]="'date' + i" [value]="date.dateTime" [ngModel]="isRadioDate && currentDate"
          (change)="setSelectedDate(date.dateTime)" required>
        <label [for]="'date' + i">
          <p class="label__display">
            <span class="label__checkbox hidden-xs hidden-sm"></span>
            {{ appCopy.panelHeader[date.dateDisplay+selectedLanguage] }}
            <span *ngIf="showPlaneIconAtIndex === i" class="icon icon--small">plane_solid</span>
          </p>
          <p class="label__date text-caption hidden-xs hidden-sm">{{ date.dateTime | date:'E d MMM yyyy' :'' :
            languageCode }}
          </p>
        </label>
        <p class="label__date text-caption hidden-md hidden-lg">{{ date.dateTime | date:'E d MMM yyyy' :'' :
          languageCode }}</p>
      </div>
    </div>

    <div class="time_slots_info">
      <h6 class="margin-top-0 margin-bottom-8 info">{{ appCopy.panelHeader['timeLable'+selectedLanguage] }}</h6>
      <p class="margin-top-0 margin-bottom-8 local-time">{{ appCopy.panelHeader['timeText'+selectedLanguage] }}</p>
    </div>

    <div class="radio-tabs">
      <div *ngFor="let group of timeslotGroups; let groupIndex = index;" class="radio radio--tab">
        <input type="radio" name="bookerType" #contactFirstName="ngModel" [id]="'timeslotGroup' + groupIndex"
          [value]="groupIndex" [(ngModel)]="selectedGroupIndex" (change)="selectSlots(groupIndex,group)" required>
        <label [for]="'timeslotGroup' + groupIndex">
          <p class="label__display">
            <span class="label__checkbox hidden-xs hidden-sm" [ngClass]="{active: groupIndex===selectedGroupIndex}"></span>
          </p>
          <div class="innerContent">
            <div>
              {{ appCopy.panelHeader[group.description+selectedLanguage] }}

              <br>

              <span class="text-caption" *ngIf="group.fromPrice !== ''">
                {{appCopy.panelHeader['from'+selectedLanguage]}} {{group.currencySymbol}}{{group.currencySymbol==="CHF"
                ?
                ' ' : ''}}{{ group.fromPrice }}</span>
            </div>
            <div style="align-self: center;">
              <div class="popup popup-{{groupIndex}}"
                *ngIf="group.description === 'Saver Slots (3hr)' || group.description === 'Super-Saver Slots (6hr)' || group.description === 'Premium Slots (1hr)' || group.description === 'Day Long Slot'">
                <i class="icon-information icon-black icon_20"></i>
                <span class="popuptext"
                  *ngIf="group.description === 'Super-Saver Slots (6hr)'">{{appCopy.panelHeader['SaverSlotsTooltip'+selectedLanguage]}}</span>
                <span class="popuptext"
                  *ngIf="group.description === 'Saver Slots (3hr)'">{{appCopy.panelHeader['SuperSaverTooltip'+selectedLanguage]}}</span>
                <span class="popuptext" *ngIf="group.description === 'Premium Slots (1hr)'">{{appCopy.panelHeader['PremiumSlotsTooltip'+selectedLanguage]}}</span>
                <span class="popuptext" *ngIf="group.description === 'Day Long Slot'">{{appCopy.panelHeader['DayLongSlotsTooltip'+selectedLanguage]}}</span>
              </div>
            </div>
          </div>
        </label>
      </div>
    </div>

    <div class="panel panel-default">
      <div class="panel-body">
        <div *ngFor="let group of timeslotGroups; let groupIndex = index;">
          <div *ngIf="groupIndex === selectedGroupIndex">
            <div class="row margin-top-8">
              <div class="col-md-4 col-md-offset-4">
                <button *ngIf="group.timeslots.length > 0 && group.scrollIndex > 0"
                  class="btn btn-ghost btn-block buttonEarlier" type="button"
                  (click)="navigateList(groupIndex, 'earlier')" (keyup.enter)="navigateList(groupIndex, 'earlier')"
                  tabindex="0">
                  {{ appCopy.panelHeader['buttonEarlier'+selectedLanguage] }}
                </button>
              </div>
            </div>

            <div class="list-group list-group--timeslots margin-top-16 margin-bottom-8"
            [style.height]="(group.timeslots.length >= slotsSetSize ? slotsSetSize * timeslotElemHeight : group.timeslots.length * timeslotElemHeight ) + (group.cheapestSlotCount * 20) +'px'">
              <div *ngIf="group.timeslots.length === 0" class="list-group-item flex-always flex--space-between">
                {{ appCopy.panelHeader['noTimeslotText'+selectedLanguage].replace('%s',
                appCopy.panelHeader[group.description+selectedLanguage]) }}
              </div>
              <div class="list-group__scroll-container"
                [style.transform]="'translate3d(0, -' + group.scrollPosition + 'px, 0)'">
                <ng-container *ngFor="let timeslot of group.timeslots">
                  <div class="timeSlotWrapper" [class.list-group-item--selected]="selectedTimeslotId === timeslot.timeslotId && selectedDate === group.dateTime" [ngClass]="(timeslot.isCheapest || timeslot.totalPriceMajor !== timeslot.totalPriceBeforeDiscountMajor )&& 'isCheapest'">
                    <div class="isCheapestLabel" *ngIf="timeslot.isCheapest || timeslot.totalPriceMajor !== timeslot.totalPriceBeforeDiscountMajor">
                      <div>
                        <span *ngIf="timeslot.isCheapest">
                          {{ appCopy.panelHeader['lowestPirce'+selectedLanguage] }}
                        </span>
                      </div>
                      <div class="priceLabel" *ngIf="timeslot.totalPriceMajor !== timeslot.totalPriceBeforeDiscountMajor">
                        <span>{{ appCopy.panelHeader['originalPirce'+selectedLanguage] }}</span>
                        <span>{{ appCopy.panelHeader['youPay'+selectedLanguage] }}</span>
                      </div>
                    </div>
                    <div class="list-group-item flex-always flex--space-between"
                      (click)="setSelectedTimeslot(timeslot, groupIndex)"
                      (keyup.enter)="setSelectedTimeslot(timeslot, groupIndex)" tabindex="0">

                      <div class="flex__item--grow flex-always flex--space-between margin-right-16">
                        {{ timeslot.startTime }} - {{ timeslot.endTime }}
                        <div class="flex-always">
                          <!-- <div class="isCheapestLabel" *ngIf="timeslot.isCheapest">
                            {{ appCopy.panelHeader['lowestPirce'+selectedLanguage] }}
                          </div> -->
                          <span *ngIf="timeslot.timeslotFlags.length > 0"
                            [ngClass]="timeslot.timeslotFlags[0] === 'Eco slot' ? 'label label-success' : 'text-caption'">
                            {{ appCopy.panelHeader[timeslot.timeslotFlags[0]+selectedLanguage] }}
                          </span>
                        </div>
                      </div>
                      <span *ngIf="timeslot.totalPriceMajor !== timeslot.totalPriceBeforeDiscountMajor" class="badge badge-default orignalPrice" [ngClass]="{ 'Buttonloading' : isTimeslotLoading || isPriceLoading}">
                        <div class="loader-container-btn" *ngIf="isTimeslotLoading || isPriceLoading">
                          <!-- <div class="loader"
                            [ngClass]="selectedTimeslotId === timeslot.timeslotId ? 'loader--white' : 'loader--gray'">
                            <svg class="circular" viewBox="25 25 50 50">
                              <circle class="path" cx="50" cy="50" r="20" />
                            </svg>
                          </div> -->
                        </div>
                          <span class="line-through"
                          *ngIf="!isTimeslotLoading && !isPriceLoading">{{group.currencySymbol}}{{group.currencySymbol==="CHF"
                          ? ' ' : ''}}{{ timeslot.totalPriceBeforeDiscountMajor }}</span>
                      </span>
                      <span class="badge badge-default" [ngClass]="{ 'Buttonloading' : isTimeslotLoading || isPriceLoading}">
                        <div class="loader-container-btn" *ngIf="isTimeslotLoading || isPriceLoading">
                          <!-- <div class="loader"
                            [ngClass]="selectedTimeslotId === timeslot.timeslotId ? 'loader--white' : 'loader--gray'">
                            <svg class="circular" viewBox="25 25 50 50">
                              <circle class="path" cx="50" cy="50" r="20" />
                            </svg>
                          </div> -->
                        </div>
                        <span
                          *ngIf="!isTimeslotLoading && !isPriceLoading">{{group.currencySymbol}}{{group.currencySymbol==="CHF"
                          ? ' ' : ''}}{{ timeslot.totalPriceMajor }}</span>
                      </span>
                    </div>
                  </div>

                </ng-container>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4 col-md-offset-4">
                <button
                  *ngIf="group.timeslots.length > 0 && (group.scrollIndex + slotsSetSize <= group.timeslots.length - 1)"
                  class="btn btn-ghost btn-block buttonLater" type="button" (click)="navigateList(groupIndex, 'later')"
                  (keyup.enter)="navigateList(groupIndex, 'later')" tabindex="0">
                  {{ appCopy.panelHeader['buttonLater'+selectedLanguage] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="timeslotDetails" tabindex="-1">

      <!-- <ng-container *ngIf="bookingProduct === 'ccd' && flightDirection === 1">
        <div class="alert alert-success flex-always flex--space-between"
          [ngClass]="bookingJourneyTimeAmended === true ? 'alert-danger-light' : 'alert-info-light'">
          <p>
            <span *ngIf="newTimeslotSelected && bookingJourneyTimeAmended && bookingType === 'amend'">
              Warning: your airport timeslot has been reset<br>
            </span>
            Collect your bags from {{ flightStatusDetails[0].departureAirport.airportName }} Terminal {{
            flightStatusDetails[0].departureAirport.airportTerminal }} on<br>
            <strong>{{ timeslots.sdsOutboundDeliveryTimeSlot.date | amParse: 'DD/MM/YYYY'
              | date:'E, d MMM yyyy' :'' : languageCode }} between {{ timeslots.sdsOutboundDeliveryTimeSlot.startTime }}
              and {{
              timeslots.sdsOutboundDeliveryTimeSlot.endTime }}</strong>
          </p>
        </div>
        <p class="text-muted">
          <em class="help-block">
            Want a different time? Finish your booking and give our team a call.
          </em>
        </p>
      </ng-container> -->

      <div class='booking-summary__bagsDropdown' *ngIf="bookingType === 'amend'">
        <!-- header -->
        <!-- <div class="flex-always flex--space-between flex--align-end dropdownHeader">
            <div class='flex-always'>
              <i class="icon">luggage</i>
              <p class='dropdown-title'>{{ appCopy.panelHeader[flightDirection === 1 ? 'bagCollectionLabel'+selectedLanguage : 'bagDeliveryLabel'+selectedLanguage] }}</p>
            </div>
            <i class="icon">{{toggleDropdown ? 'chevron_up' : 'chevron_down'}}</i>
          </div> -->
        <!-- body -->
        <div *ngIf="toggleDropdown" [@Dropdown] class="dropdownBody">
          <!-- Bags -->
          <div class="dropdown-item">
            <div class='flex-always g-23'>
              <div class="bagtooltip margin-right-8">
                <span class="icon-span icon-span-small tooltip-trigger-text">
                  <span class="icon-information icon-black icon_12">
                  </span>
                </span>
                <span
                  class="tooltiptext tooltip-right-bottom">{{appCopy.panelHeader['bagInfoText'+selectedLanguage]}}</span>
              </div>
              <span class="text-extra-bold">{{ appCopy.panelHeader[bagItems.bags > 1 ? 'bagsSelectText' +
                selectedLanguage :
                'bagSelectText' + selectedLanguage] }}</span>
            </div>
            <div class='bag--buttons flex-always'>
              <button (click)="updateBagItems(bagItems.bags-1, 'bags')"
                class='iconBtn icon-span icon-span-small margin-right-8'
                [disabled]="bagItems.bags === 0 || showLoader || isPriceLoading || isTimeslotLoading">
                <span class="icon-minus icon-black icon_16">
                </span>
              </button>
              <strong class="dropdown-item--value">{{bagItems.bags}}</strong>
              <button (click)="updateBagItems(bagItems.bags+1, 'bags')"
                class='iconBtn icon-span icon-span-small margin-left-8'
                [disabled]="virtualBags > 25 || showLoader || isPriceLoading || isTimeslotLoading">
                <span class="icon-plus-outline icon-black icon_16">
                  <span class='path1'></span>
                  <span class='path2'></span>
                </span>
              </button>
            </div>
          </div>
          <!-- child Equipment -->
          <div class="dropdown-item">
            <div class='flex-always g-23'>
              <div class="bagtooltip margin-right-8">
                <span class="icon-span icon-span-small tooltip-trigger-text">
                  <span class="icon-information icon-black icon_12">
                  </span>
                </span>
                <span
                  class="tooltiptext tooltip-right-bottom">{{appCopy.panelHeader['childItemInfoText'+selectedLanguage]}}</span>
              </div>
              <span class="text-extra-bold">{{ appCopy.panelHeader['childItemLable' + selectedLanguage] }}</span>
            </div>
            <div class='bag--buttons flex-always'>
              <button (click)="updateBagItems(bagItems.childEquipment-1, 'childEquipment')"
                class='iconBtn icon-span icon-span-small margin-right-8'
                [disabled]="bagItems.childEquipment === 0 || showLoader || isPriceLoading || isTimeslotLoading">
                <span class="icon-minus icon-black icon_16">
                </span>
              </button>
              <strong class="dropdown-item--value">{{bagItems.childEquipment}}</strong>
              <button (click)="updateBagItems(bagItems.childEquipment+1, 'childEquipment')"
                class='iconBtn icon-span icon-span-small margin-left-8'
                [disabled]="virtualBags > 25 || showLoader || isPriceLoading || isTimeslotLoading">
                <span class="icon-plus-outline icon-black icon_16">
                  <span class='path1'></span>
                  <span class='path2'></span>
                </span>
              </button>
            </div>
          </div>
          <!-- Oversize item -->
          <div class="dropdown-item">
            <div class='flex-always g-23'>
              <div class="bagtooltip margin-right-8">
                <span class="icon-span icon-span-small tooltip-trigger-text">
                  <span class="icon-information icon-black icon_12">
                  </span>
                </span>
                <span
                  class="tooltiptext tooltip-right-bottom">{{appCopy.panelHeader['supportItemInfoText'+selectedLanguage]}}</span>
              </div>
              <span class="text-extra-bold">{{ appCopy.panelHeader['supportItemLable' + selectedLanguage] }}</span>
            </div>
            <div class='bag--buttons flex-always'>
              <button (click)="updateBagItems(bagItems.oversizeItem-1, 'oversizeItem')"
                class='iconBtn icon-span icon-span-small margin-right-8'
                [disabled]="bagItems.oversizeItem === 0 || showLoader || isPriceLoading || isTimeslotLoading">
                <span class="icon-minus icon-black icon_16">
                </span>
              </button>
              <strong class="dropdown-item--value">{{bagItems.oversizeItem}}</strong>
              <button (click)="updateBagItems(bagItems.oversizeItem+1, 'oversizeItem')"
                class='iconBtn icon-span icon-span-small margin-left-8'
                [disabled]="virtualBags > 25 || showLoader || isPriceLoading || isTimeslotLoading">
                <span class="icon-plus-outline icon-black icon_16">
                  <span class='path1'></span>
                  <span class='path2'></span>
                </span>
              </button>
            </div>
          </div>
          <div class='bag-error'>
            <p *ngIf="virtualBags === 0" class='has-error'>{{appCopy.panelHeader['zeroBagItemError'+selectedLanguage]}}
            <p *ngIf="virtualBags > 25" class='has-error'>{{appCopy.panelHeader['maxBagItemError'+selectedLanguage]}}
            </p>
          </div>
        </div>
      </div>
      <!-- <p *ngIf="bagItems.bags===0 && bagItems.oversizeItem === 0 && bagItems.childEquipment === 0"
        class='alert alert-danger p-10'>There should be at least one item to continue</p> -->
      <!-- <div class="form-group with-icon with-select" >
        <i class="icon">luggage</i>
        <select #BagCount class="form-control" id="BagCount" name="BagCount" [(ngModel)]="virtualBags"
          (ngModelChange)="updateBags($event)" appCheckEmpty>
          <option value="" disabled></option>
          <option *ngFor="let bagNb of bagsArr" [value]="bagNb">{{ bagNb }} {{ bagNb === 1 ?
            appCopy.panelHeader['bagSelectText'+selectedLanguage] :
            appCopy.panelHeader['bagsSelectText'+selectedLanguage] }}</option>
        </select>
        <label class="control-label" for="BagCount">{{ flightDirection === 1 ?
          appCopy.panelHeader['bagCollectionLabel'+selectedLanguage] :
          appCopy.panelHeader['bagDeliveryLabel'+selectedLanguage]
          }}</label>
      </div> -->
    </div>

    <!-- || ((valueslots_available + premslots_available) > 5) -->
    <!-- <div *ngIf="bookingType === 'amend' || selectedTimeslotId " class="checkbox checkbox--default margin-bottom-24">
      <input type="checkbox" name="hasOversizedBag" id="hasOversizedBag" [(ngModel)]="hasOversizedBag"
        (click)="overSizeBag($event)">
      <label for="hasOversizedBag">{{ appCopy.panelHeader['bagButtonCheckLabel'+selectedLanguage] }}</label>
    </div> -->

    <div *ngIf="bookingProduct === 'abc' && bookingType !== 'amend' && selectedTimeslotId && isConditionalAcceptence"
      class="alert alert-success flex flex-always">
      <i class="icon margin-right-16">info</i>
      {{ appCopy.passengerRules[languageCode] }}
    </div>

    <!-- && ((valueslots_available + premslots_available) < 5) -->
    <div *ngIf="bookingType !== 'amend' && !selectedTimeslotId " class="checkbox checkbox--default margin-bottom-24">
      <input type="checkbox" name="cantFindTime" id="cantFindTime" [(ngModel)]="cantFindTime"
        (click)="cantFindBooking($event)">
      <label for="cantFindTime">{{ appCopy.panelHeader['cantFindTimeCheckLabel'+selectedLanguage] }}</label>
    </div>

    <ng-container
      *ngIf="(bookingProduct === 'ccd' && arrivalAirlineCode === 'ZRH') || (bookingProduct === 'abc' && departureAirlineCode === 'ZRH'); then zhr; else notZhr">
    </ng-container>

    <ng-template #zhr>
      <div *ngIf="bookingType !== 'amend' && cantFindTime && !selectedTimeslotId"
        class="alert alert-success flex flex-always">
        <i class="icon margin-right-16">info</i>
        <div [innerHTML]="appCopy.panelHeader['cantFindTimeMessage'+selectedLanguage]"></div>
      </div>
      <button id="formBagPickupTimeDate-submit" type="button" style="background-color: #7850FA;color: white;"
      [ngClass]="{'Buttonloading' : isTimeslotLoading || isPriceLoading || showLoader}" class="btn btn-block margin-bottom-24" (click)="handleSubmit($event)"
        [disabled]="
        showLoader
        || virtualBags > 25
        || virtualBags === 0
        ||isTimeslotLoading
        || isPriceLoading
        || (bookingType !== 'amend' && timeslotsData.selectedTimeslotId === null)
        || (bookingType === 'amend' && !bookingData.booking.changedLocationFlag && !bookingData.booking.changedBagsFlag && !bookingData.booking.changedTimeslotFlag && price.priceHistory.majorPriceDifference === 0)
        || (bookingType === 'amend' && bookingData.booking.changedLocationFlag && !bookingData.booking.changedTimeslotFlag)">
        <!-- <div class="loader-container-btn" *ngIf="isTimeslotLoading || isPriceLoading || showLoader">
          <div class="loader loader--white">
            <svg class="circular" viewBox="25 25 50 50">
              <circle class="path" cx="50" cy="50" r="20" />
            </svg>
          </div>
        </div> -->
        <span *ngIf="!isTimeslotLoading && !isPriceLoading && !showLoader">
          {{ appCopy.panelHeader['buttonContinue'+selectedLanguage] }}
        </span>
      </button>
    </ng-template>



    <ng-template #notZhr>
      <div *ngIf="bookingType !== 'amend' && cantFindTime && !selectedTimeslotId"
        class="alert alert-success flex flex-always">
        <i class="icon margin-right-16">info</i>
        <div [innerHTML]="appCopy.panelHeader['cantFindTimeNotZrhMessage'+selectedLanguage] "></div>
      </div>
      <button id="formBagPickupTimeDate-submit" type="button" style="background-color: #7850FA;color: white;"
        [ngClass]="{'Buttonloading' : isTimeslotLoading || isPriceLoading || showLoader}" class="helloooo btn btn-block margin-bottom-24" (click)="handleSubmit($event)"
        [disabled]="
        showLoader
        || virtualBags > 25
        || virtualBags === 0
        ||isTimeslotLoading
        || isPriceLoading
        || (bookingType !== 'amend' && timeslotsData.selectedTimeslotId === null)
        || (bookingType === 'amend' && !bookingData.booking.changedLocationFlag && !bookingData.booking.changedBagsFlag && !bookingData.booking.changedTimeslotFlag && price.priceHistory.majorPriceDifference === 0)
        || (bookingType === 'amend' && bookingData.booking.changedLocationFlag && !bookingData.booking.changedTimeslotFlag)">
        <!-- <div class="loader-container-btn" *ngIf="isTimeslotLoading || isPriceLoading || showLoader">
          <div class="loader loader--white">
            <svg class="circular" viewBox="25 25 50 50">
              <circle class="path" cx="50" cy="50" r="20" />
            </svg>
          </div>
        </div> -->
        <span *ngIf="!isTimeslotLoading && !isPriceLoading && !showLoader">
          {{ appCopy.panelHeader['buttonContinue'+selectedLanguage] }}
        </span>
      </button>
    </ng-template>
  </form>

</section>
